<template>
  <q-card flat bordered>
    <q-card-section class="flex justify-between">
      <div>
        <div class="text-h6">Organization Name</div>
        <div style="font-size: 12px">
          Update your organization's display name to match your company branding.
        </div>
      </div>
      <div class="q-my-auto" v-if="canSave">
        <q-btn
          v-if="organizationName"
          label="Save"
          icon="save"
          unelevated
          no-caps
          :loading="saveLoading"
          :color="canSaveOrganizationName ? 'primary' : 'grey'"
          :disable="!canSaveOrganizationName"
          @click="updateOrganizationName"
        />
      </div>
    </q-card-section>
    <q-separator />
    <q-card-section class="flex">
      <q-input
        v-model="newOrganizationName"
        outlined
        class="text-h6 col"
        placeholder="Enter an organization name"
        clearable
      >
        <template #prepend>
          <q-icon name="business" />
        </template>
      </q-input>
    </q-card-section>
  </q-card>
</template>
<script lang="ts">
import { useUserStore } from '@/stores/user'

export default {
  name: 'OrganizationName',
  data() {
    return {
      organizationName: null as string | null,
      newOrganizationName: null as string | null,
      saveLoading: false
    }
  },
  computed: {
    organization() {
      return useUserStore().organization
    },
    canSaveOrganizationName() {
      return (
        this.newOrganizationName &&
        this.newOrganizationName !== this.organization?.display_name &&
        this.newOrganizationName.length > 0
      )
    },
    canSave() {
      return (
        this.newOrganizationName &&
        this.newOrganizationName.length > 0 &&
        this.newOrganizationName !== this.organization?.display_name
      )
    }
  },
  watch: {
    organization() {
      this.organizationName = useUserStore().organization?.display_name || 'Unknown'
      this.newOrganizationName = this.organizationName
    }
  },
  mounted() {
    this.organizationName = useUserStore().organization?.display_name || 'Unknown'
    this.newOrganizationName = this.organizationName
  },
  methods: {
    updateNewOrganizationName(value: string | null) {
      this.newOrganizationName = value
    },
    updateOrganizationName() {
      if (
        this.newOrganizationName &&
        this.organization &&
        this.newOrganizationName !== this.organization.display_name
      ) {
        this.saveLoading = true
        useUserStore()
          .updateOrganization(this.organization.id, {
            display_name: this.newOrganizationName,
            owner_user_id: this.organization.owner_user_id,
            admin_user_ids: this.organization.admin_user_ids,
            connection_id: this.organization.connection_id,
            logo_url: this.organization.logo_url,
            report_tags: this.organization.report_tags,
            use_security_groups: this.organization.use_security_groups,
            sections: this.organization.sections,
            columns: this.organization.columns
          })
          .then(() => {
            this.$q.notify({
              message: 'Organization name updated to ' + this.newOrganizationName,
              color: 'green'
            })
          })
          .finally(() => {
            this.organizationName = useUserStore().organization?.display_name || null
            this.saveLoading = false
          })
      } else {
        this.organizationName = useUserStore().organization?.display_name || null
      }
    }
  }
}
</script>
